<template>
    <div class="page">
        <!-- if collection page - mobile description -->
        <div class="catalog">
            <h1 class="text_13 catalog__title" v-if="!mimicry">
                {{ drop.name }}
            </h1>
            <div class="catalog__description" v-if="drop.description" v-html="drop.text"></div>
            <div class="row flex-row row--fullwidth">
                <template v-for="(product, p_index) in drop.skus">
                    <div class="col lg-3 sm-6 col--no-padding" :key="product.id">
                        <Product
                            :data="product"
                            :index="p_index + 1"
                            @update:showProductDetails="doMimicry($event)"
                            :openInModal="true"></Product>
                    </div>
                </template>
            </div>
        </div>
        <transition name="fade-in-left">
            <div class="productModal" v-if="productModal" v-bsl="!!productModal">
                <productPageComponent
                    is-modal
                    gender="all"
                    @modalClose="resetView()"
                    @update:product="$store.commit('catalog/updateProductModalProduct', $event)"
                    :product="productModal.product"></productPageComponent>
            </div>
        </transition>
    </div>
</template>

<script>
import Product from "../../components/Product.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
    name: "DropsPage",
    components: {
        Product,
        productPageComponent: () => import("@/components/ProductPage.vue"),
    },
    async asyncData({ params, redirect, store }) {
        try {
            const drop = store.state.collections.drops.find((d) => d.slug === params.slug);

            if (!drop || !drop.skus.length) {
                redirect("/404");
            }

            const crumbs = [{ name: drop.name }];

            return {
                drop,
                mimicry: null,
                crumbs,
            };
        } catch (error) {
            redirect("/404");
        }
    },
    watch: {
        location(val) {
            if (val === this.$route.path) {
                this.mimicry = false;
                this.$store.commit("crumbs/change", this.crumbs);
            }
        },
        async langust(val, oldVal) {
            if (oldVal) {
                await this.$nuxt.refresh();
                this.$store.commit("crumbs/change", this.crumbs);
            }
        },
    },
    computed: {
        ...mapGetters({
            locale: "globalvars/getLocale",
            langust: "globalvars/getLang",
            productModal: "catalog/getProductModal",
        }),
        location() {
            return process.client ? window.location.href : "";
        },
    },
    methods: {
        ...mapMutations("catalog", ["updateProductModal"]),
        doMimicry(data) {
            this.mimicry = data.mimicry;
        },
        resetView() {
            this.mimicry = false;
            this.updateProductModal(null);
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    created() {
        this.$nuxt.$on("update-location-href", this.resetView);
        this.$store.commit("crumbs/change", this.crumbs);
    },
    mounted() {
        this.$grom.pushGTMshowProducts(this.drop.skus);
        window.addEventListener("popstate", this.resetView, false);
    },
    beforeDestroy() {
        window.removeEventListener("popstate", this.resetView, false);
    },
};
</script>
<style lang="less">
.fade-in-left-leave-active {
    .catalog__title {
        opacity: 0;
    }
}
.catalog {
    &__title {
        height: 36px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        opacity: 1;
        .trs(all);
        // @media @notsm {
        //     .is_scrolled & {
        //         transform: translate(-50%, -100%);
        //     }
        // }
        @media @sm {
            position: static;
            width: 100%;
            transform: none;
            justify-content: center;
            border-bottom: 1px solid @border2;
            height: initial;
            padding: 0 7px 0 16px;
        }
    }
    &__description {
        line-height: 150%;
        ::v-deep {
            p + p,
            ul + p {
                margin-top: 12px;
            }
            p + ul {
                margin-top: 15px;
            }
            li + li {
                margin-top: 8px;
            }
            ul {
                padding-bottom: 3px;
            }
            li {
                display: flex;
                align-items: flex-start;
                line-height: 15px;
                &:before {
                    content: "";
                    display: block;
                    width: 6px;
                    height: 6px;
                    background: url(../../assets/icons/crystal.svg?inline) center / contain no-repeat;
                    margin-right: 8px;
                    margin-top: 5px;
                    flex-shrink: 0;
                    @media @sm {
                        margin-top: 7px;
                        .is_apple & {
                            margin-top: 6px;
                        }
                    }
                    .is_apple & {
                        margin-top: 4px;
                    }
                }
            }
        }
    }
}
</style>
